export class AppSettings {
    public static readonly apiEndpoint = window['__env'].apiEndpoint.indexOf('http') == 0 ? window['__env'].apiEndpoint : (document.URL.substr(0, document.URL.indexOf(document.location.pathname)) + window['__env'].apiEndpoint);
    public static readonly uiEndpoint = window['__env'].uiEndpoint.indexOf('http') == 0 ? window['__env'].uiEndpoint : (document.URL.substr(0, document.URL.indexOf(document.location.pathname)) + window['__env'].uiEndpoint);
    public static readonly googleApiKey = window['__env'].googleApiKey;
    public static readonly googleGeocodeUrl = window['__env'].googleGeocodeUrl;

}


// WEBPACK FOOTER //
// ./src/app/infrastructure/settings/app-settings.ts